export const SET_DATA = 'SET_DATA';
export const DATA_WITH_PAGINATION_CONCAT = 'DATA_WITH_PAGINATION_CONCAT';